<template>
  <div>
    <div class="verified-usa" :class="{ mobile: Base.checkSysteam() === 'MOBILE' }" v-if="isShow">
      <div class="dialog">
        <div class="close" @click="isShow = false"></div>
        <div class="dialog-header">{{ title || $t('message.ageConfirm') }}</div>
        <div class="tip">
          <div>{{ $t('message.selectAgeRange') }}</div>
          <div>
            {{ $t('message.limitTip') }}
          </div>
        </div>
        <div class="btns">
          <div class="btn" @click="handleNext('0_13')">
            {{ $t('message.age13') }}
          </div>
          <div class="btn" @click="handleNext('14_17')">
            {{ $t('message.age14_17') }}
          </div>
          <div class="btn" @click="handleNext('18+')">
            {{ $t('message.age18') }}
          </div>
        </div>
      </div>
    </div>
    <pay-failed ref="payFailed" />
  </div>
</template>

<script>
import { postFetch } from "../../utils/request";
import Base from "../../utils/base";
import { RSSign } from "../../utils/sign";
import payFailed from "../payFailed/index.vue";
import Storage from "../../utils/storage";

export default {
  data() {
    return {
      Base,
      isShow: false,
      resolve: null,
    };
  },
  props: {
    pid: {
      type: String,
      default: "",
    },
    appid: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
  },
  components: { payFailed },
  methods: {
    // 判断是否是美国用户
    async isUsaUser() {
      return true;
    },
    fail(message, title = this.$t('message.ageConfirm')) {
      this.isShow = false;
      this.title = title;
      this.$refs.payFailed.show(message);
    },
    handleNext(age_group) {
      this.isShow = false
      let uinfo = Storage.localStorageGet("_XH_U_WEBSDK");
      let _this = this;
      let data = {
        nonce: Base.nonce(12),
        version: Base.getVersion(),
        tm: new Date().getTime(),
        sdk_ver: Base.sdkVer(),
        cch_id: _this.pid,
        app_id: _this.appid,
        sys_language: Storage.localStorageGet("lang"),
        time_zone: Base.timeZone(),
        pf_type: "pc-websdk",
        age_group,
        biz_region: "en",
        uinfo,
      };
      console.log(data);

      data.device_id = Storage.localStorageGet("deviceIdUa");
      // data.uinfo = this.$Ciphertext.AESkey(info);

      data.sign = RSSign(data, data.app_id);
      postFetch(
        "https://gamepay.rastargames.com/v1/user/age-quota/commit/",
        data
      ).then(() => {
        console.log('success');
        this.resolve();
      })
    },
    check() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.isUsaUser().then((res) => {
          if (res) {
            this.isShow = true;
          } else {
            resolve();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.verified-usa {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog {
    width: 409px;
    height: 390px;
    background: #fff;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;
    animation: dialog-appearance 0.2s;

    .close {
      position: absolute;
      top: 25px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: url("../../assets/dialog-close.png") no-repeat center;
    }

    .dialog-header {
      position: relative;
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      font-size: 20px;
      color: #191919;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .tip {
      font-weight: 500;
      font-size: 16px;
      color: #a7a7a7;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      width: 261px;
      height: 61px;
    }

    .btns {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .btn {
        background: linear-gradient(to right, #ed8d8a 1px, #ea6461);
        color: #fff;
        width: 362px;
        height: 60px;
        border-radius: 10px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  // 移动端样式
  &.mobile {
    .dialog {
      max-width: 85vw;
      overflow: hidden;

      .btns {
        width: 100%;

        .btn {
          width: 100%;
          flex-shrink: 0;

          span {
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
